import { render, staticRenderFns } from "./ListPackage.vue?vue&type=template&id=36ec6dfd&scoped=true&lang=pug"
import script from "./ListPackage.vue?vue&type=script&lang=js"
export * from "./ListPackage.vue?vue&type=script&lang=js"
import style0 from "./ListPackage.vue?vue&type=style&index=0&id=36ec6dfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec6dfd",
  null
  
)

export default component.exports